import React, {PureComponent} from 'react';
import I18n from 'app/i18n';
import {SimpleArtifactImage} from 'app/components/my_profile/artifacts/image';
import round from 'lodash/round';
import HeroSlotCount from 'app/utils/hero/hero_slot_count';
import {translatedName} from 'app/utils/translations_helper';
import {FILTER_GAME_CS, FILTER_GAME_DOTA} from 'app/consts';
import {stringTypeOfBonus} from 'app/utils/stringTypeOfBonus';
import SpriteIcon from 'app/utils/sprites/SpriteIcon';

const FROZEN_BADGE_ICON_SIZE = 18;

export default class Prize extends PureComponent {
    render() {
        const {loot: {points_amount, money_amount, frozen_money_amount, bonus_amount, bonus, recipe, steam_skin},
            changePrizeArray, keyArray} = this.props;

        switch (true) {
        case Number(points_amount) > 0:
            return <DigitalPrizeImage
                amount={points_amount}
                measure={I18n.t('points', {count: points_amount})}
                changePrizeArray={changePrizeArray}
                keyArray={keyArray}
            />;
        case Number(money_amount) > 0:
            return <DigitalPrizeImage
                amount={money_amount}
                prefix="$"
                changePrizeArray={changePrizeArray}
                keyArray={keyArray}
            />;
        case Number(frozen_money_amount) > 0:
            return <DigitalPrizeImage
                amount={frozen_money_amount}
                measure={I18n.t('frozen_balance')}
                variant="frozen"
                changePrizeArray={changePrizeArray}
                keyArray={keyArray}
            />;
        case bonus !== null:
            return <DigitalPrizeImage
                amount={bonus_amount}
                prefix="$"
                measure={stringTypeOfBonus(bonus)}
                changePrizeArray={changePrizeArray}
                keyArray={keyArray}
            />;
        default:
            return <ArtifactPrizeImage
                artifact={recipe || steam_skin || this.props.recipe}
                showHeroSlotCount
                changePrizeArray={changePrizeArray}
                keyArray={keyArray}
            />;
        }
    }
}

class DigitalPrizeImage extends PureComponent {
    get amount() {
        const {prefix = '', amount} = this.props;
        return `${prefix}${round(amount, 2)}`;
    }

    get title() {
        const {measure} = this.props;
        return `${this.amount} ${measure || ''}`.trim();
    }

    render() {
        const {measure, changePrizeArray, keyArray, variant} = this.props;
        const isFrozen = variant === 'frozen';
        const prizeMarkup = <div className={`bonus-box${isFrozen ? ' bonus-box--frozen' : ''}`} title={this.title}>
            <SpriteIcon name="#svg-icon-bonus" className={`bonus-icon${isFrozen ? ' bonus-icon--frozen' : ''}`}/>
            <div className="bonus-description">
                <span className="bonus-preview__amount">
                    {isFrozen && <SpriteIcon
                        name="#svg-balance-frozen"
                        className="bonus-preview__frozen-icon"
                        size={{height: FROZEN_BADGE_ICON_SIZE, width: FROZEN_BADGE_ICON_SIZE}}
                    />}
                    {this.amount}
                </span>
                {measure && !isFrozen && <span className="bonus-preview__measure">{measure}</span>}
            </div>
        </div>;
        return <div className="hero__box">
            <div
                name={'prize'}
                ref={prize => changePrizeArray ? changePrizeArray(prize, keyArray) : null
                } className={'hero__img game '}>
                <div className="hero__slot--img">
                    {prizeMarkup}
                </div>
            </div>
            <div className="hero__box--title">
                {!isFrozen && <span className="hero__box--title-amount">{this.amount}</span>}
                {measure && <span className="hero__box--title-measure">{measure}</span>}
            </div>
        </div>;
    }
}

class ArtifactPrizeImage extends PureComponent {
    gameStyle() {
        switch (this.props.artifact.game_id) {
        case FILTER_GAME_CS:
            return 'game_csgo';
        case FILTER_GAME_DOTA:
            return 'game_dota2';
        default:
            return '';
        }
    }

    render() {
        const {artifact, showHeroSlotCount, showHeroSlotCountOrange, changePrizeArray, keyArray} = this.props;

        if (!artifact) {
            return null;
        }

        return <div className="hero__box">
            <div
                name={'prize'}
                ref={prize => changePrizeArray ? changePrizeArray(prize, keyArray) : null}
                className={`hero__img game ${this.gameStyle()}`}
            >
                <div className="hero__slot--img">
                    <SimpleArtifactImage artifact={artifact}/>
                </div>
                {
                    (showHeroSlotCount || showHeroSlotCountOrange) &&
                    <HeroSlotCount {...artifact} showHeroSlotCountOrange={showHeroSlotCountOrange}/>
                }
            </div>
            <div className="hero__box--title">{translatedName(artifact)}</div>
        </div>;
    }
}
